import request from "@/utils/request"
import { getLocale } from "@/utils/locale"
import { isStandalone } from "@/utils/standalone"

export default ({ token, code, zip, countryCode, currency, seats, productType = "subscriptions", skus, vatNumber } = {}) => {
  let url = `/api/${productType === "teams" ? "teams_" : ""}plans`
  const params = {
    locale: getLocale(),
    ...(isStandalone() ? { standalone: true } : {})
  }
  if (token) {
    url += `/${token}`
  }
  if (code) {
    params["coupon_code"] = code
  }
  if (countryCode) {
    params["country"] = countryCode
  }
  if (zip) {
    params["postal_code"] = zip
  }
  if (currency) {
    params["currency"] = currency
  }
  if (seats) {
    params["seats"] = seats
  }
  if (skus) {
    params["skus"] = skus.join(",")
  }
  if (vatNumber) {
    params["vat_number"] = vatNumber
  }

  return request.get(url, {
    params,
    token: true
  })
}
